import { getGoogleCredentials } from './getGoogleCredentials';

export const autenticationURL = (LMS, institutionCode, options = null) => {
	const getInstitutionData = (code) => {
		switch (code) {
			case 'CMVC':
				return {
					domain: 'https://compumed.instructure.com',
					redirect: 'https://olib.compumed.edu',
					clientID: process.env.REACT_APP_CLIENTID_CMVC_CANVAS,
				};
			case 'ASP':
				return {
					domain: 'https://aspatria.instructure.com',
					redirect: 'https://asp-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_ASP,
				};
			case 'DOINS':
				return {
					domain: 'https://dominiuminstitute.instructure.com',
					redirect: 'https://library-dominiuminstitute.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_DOINS,
				};
			case 'UTH':
				return {
					domain: 'https://uthflorida.instructure.com',
					redirect: 'https://library.uthfloridauniversity.com',
					clientID: process.env.REACT_APP_CLIENTID_UTH,
				};
			case 'HCAS':
				return {
					domain: 'https://hcas.instructure.com',
					redirect: 'https://hcas-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_HCAS,
				};
			case 'CMVC_moodle':
				return {
					domain: 'https://campus.compumed.edu',
					clientID: process.env.REACT_APP_CLIENTID_CMVC_MOODLE,
				};
			case 'AMHEALTH':
				return {
					domain: 'https://moodle.amhealthinstitute.com',
					clientID: process.env.REACT_APP_CLIENTID_AMHEALTH,
				};
			case 'MACKENZIE':
				return {
					domain: 'https://campus.mackenzieonline.university',
					clientID: process.env.REACT_APP_CLIENTID_MACKENZIE,
				};
			case 'GAPAT':
				return {
					domain: 'https://gapat.net/Mood',
					clientID: process.env.REACT_APP_CLIENTID_GAPAT,
				};
			case 'UNAD':
				return {
					domain: 'https://unad.us/Season2025A',
					clientID: process.env.REACT_APP_CLIENTID_UNAD,
				};
			case 'UNAD_2':
				return {
					domain: 'https://unad.us/Season2025B',
					clientID: process.env.REACT_APP_CLIENTID_UNAD_2,
				};
			case 'SUMMA':
				return {
					domain: 'https://centro-virtual.com/campus',
					clientID: process.env.REACT_APP_CLIENTID_SUMMA,
				};
			case 'AHIS':
				return {
					domain: 'https://myelearning.ahimiami.com',
					clientID: process.env.REACT_APP_CLIENTID_AHIS,
				};
			case 'AHIS_2':
				return {
					domain: 'https://elearning.ahimiami.com',
					clientID: process.env.REACT_APP_CLIENTID_AHIS_2,
				};
			case 'SAU':
				return {
					domain: 'https://classroom.sabal.university',
					clientID: process.env.REACT_APP_CLIENTID_SAU,
				};
			case 'FGU':
				return {
					domain: 'https://virtual.floridaglobal.university',
					clientID: process.env.REACT_APP_CLIENTID_FGU,
				};
			case 'ABC':
				return {
					domain: 'https://virtual.americanbusiness.college',
					clientID: process.env.REACT_APP_CLIENTID_ABC,
				};
			case 'CBT':
				return {
					domain: 'https://CBT.instructure.com',
					redirect: 'https://olib.cbt.edu',
					clientID: process.env.REACT_APP_CLIENTID_CBT,
				};
			case 'SABER':
				return {
					domain: 'https://sabercollege.instructure.com',
					redirect: 'https://olib.sabercollege.edu',
					clientID: process.env.REACT_APP_CLIENTID_SABER,
				};
			case 'BRC':
				return {
					domain: 'https://braxtoncollege.instructure.com',
					redirect: 'https://brc-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_BRC,
				};
			case 'LSN':
				return {
					domain: 'https://lsn.instructure.com',
					redirect: 'https://lsn-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_LSN,
				};
			case 'ST':
				return {
					domain: 'https://stratatech.instructure.com',
					redirect: 'https://strata-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_ST,
				};
			case 'MIAMI_BROWARD':
				return {
					domain: 'https://broward.aquinasnetwork.com',
					clientID: process.env.REACT_APP_CLIENTID_MIAMI_BROWARD,
				};
			case 'ALEPH':
				return {
					domain: 'https://programs.alephuniversity.us',
					clientID: process.env.REACT_APP_CLIENTID_ALEPH,
				};
			case 'IHU':
				return {
					domain: 'https://campus.international-holistic.university',
					clientID: process.env.REACT_APP_CLIENTID_IHU,
				};
			case 'ILUNI':
				return {
					domain: 'https://upanavirtual-test.blackboard.com', // LOGIN URL
					redirect: 'https://iluni-library.aquinasnetwork.tech', // REDIRECT URL
					clientID: process.env.REACT_APP_CLIENTID_ILUNI, // CLIENT ID
				};
			// case 'GTFU':
			// 	return {
			// 		domain: 'https://uees.blackboard.com', // LOGIN URL
			// 		redirect: 'https://globaltech-library.aquinasnetwork.tech', // REDIRECT URL
			// 		clientID: process.env.REACT_APP_CLIENTID_GTFU, // CLIENT ID
			// 	};
			case 'BETAUNI':
				return {
					domain: 'https://betauni.instructure.com',
					redirect: 'https://betauni-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_BETAUNI_CANVAS,
				};
			case 'LAURELI':
				return {
					domain: 'https://lbi.instructure.com',
					redirect: 'https://laureli-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_LAURELI_CANVAS,
				};
			case 'OBC':
				return {
					domain: 'https://obc.instructure.com',
					redirect: 'https://obc-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_OBC_CANVAS,
				};
			case 'MTA':
				return {
					domain: 'https://mta.instructure.com',
					redirect: 'https://mta-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_MTA_CANVAS,
				};
			case 'DTH':
				return {
					domain: 'https://dadeinstitute.instructure.com',
					redirect: 'https://dade-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_DTH_CANVAS,
				};
			case 'SMUR':
				return {
					domain: 'https://canvas.smufl.us',
					redirect: 'https://shenandoah-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_SMUR_CANVAS,
				};
			case 'OMI':
				return {
					domain: 'https://omi.instructure.com',
					redirect: 'https://omi-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_OMI_CANVAS,
				};
			case 'AES':
				return {
					domain: 'https://virtual.americanelite.school',
					clientID: process.env.REACT_APP_CLIENTID_AES_MOODLE,
				};
			case 'IBECAM':
				return {
					domain: 'https://campus.ibecamuniversity.com',
					clientID: process.env.REACT_APP_CLIENTID_IBECAM_MOODLE,
				};
			case 'PPD':
				return {
					domain: 'https://virtualppduniversity.com/moodle',
					clientID: process.env.REACT_APP_CLIENTID_PPD_MOODLE,
				};
			case 'BIRCHU':
				return {
					domain: 'https://learn.birchwoodu.org',
					clientID: process.env.REACT_APP_CLIENTID_BIRCHU_MOODLE,
				};
			case 'IUM':
				return {
					domain: 'https://campus.unimiami.university',
					clientID: process.env.REACT_APP_CLIENTID_IUM_MOODLE,
				};
			case 'MIAMINSTITUTE':
				return {
					domain: 'https://mycampus2026.miaminstitute.education', // MIAMINSTITUTE
					clientID: process.env.REACT_APP_CLIENTID_MIAMINSTITUTE_MOODLE,
				};
			case 'NEXTL':
				return {
					domain: 'https://universityseal.evolveeduc.com',
					clientID: process.env.REACT_APP_CLIENTID_NEXTL_MOODLE,
				};
			case 'FAMA':
				return {
					domain: 'https://moodle.famaedu.com',
					clientID: process.env.REACT_APP_CLIENTID_FAMA_MOODLE,
				};
			case 'FOU':
				return {
					domain: 'https://classroom.floridaopen.university',
					clientID: process.env.REACT_APP_CLIENTID_FOU_MOODLE,
				};
			case 'GTFU':
				return {
					domain: 'https://classroom.globaltechflorida.university',
					clientID: process.env.REACT_APP_CLIENTID_GTFU_MOODLE,
				};
			case 'DUARTE':
				return {
					domain: 'https://duarteuniversity-test.online',
					clientID: process.env.REACT_APP_CLIENTID_DUARTE_MOODLE,
				};
			case 'PCI':
				return {
					domain: 'https://learn.pcihealth.edu',
					redirect: 'https://pci-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_PCI,
				};
			case 'VANDALIA':
				return {
					domain: 'https://wvjc.instructure.com',
					redirect: 'https://vandalia-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_VANDALIA_CANVAS,
				};
			case 'DRU':
				return {
					domain: 'https://dionisioromerouniversity.instructure.com',
					redirect: 'https://dru-library.aquinasnetwork.tech',
					clientID: process.env.REACT_APP_CLIENTID_DRU_CANVAS,
				};
			case 'DEV': // ESTE ES SOLO DE PRUEBA
				return {
					domain: 'https://upanavirtual-test.blackboard.com', // LOGIN URL
					redirect: 'https://olib-dev.vercel.app', // REDIRECT URL
					clientID: process.env.REACT_APP_CLIENTID_ILUNI,
				};

			default:
				return {
					domain: 'https://compumed.instructure.com',
					redirect: 'https://olib.compumed.edu',
					clientID: process.env.REACT_APP_CLIENTID_CMVC_CANVAS,
				};
		}
	};

	if (LMS === 'moodle' || LMS === 'moodle 2.9') {
		if (institutionCode === 'CMVC') {
			return `${
				getInstitutionData(institutionCode.concat('_moodle')).domain
			}/local/oauth/login.php?client_id=${
				getInstitutionData(institutionCode.concat('_moodle')).clientID
			}&response_type=code`;
		} else {
			return `${
				getInstitutionData(institutionCode).domain
			}/local/oauth/login.php?client_id=${
				getInstitutionData(institutionCode).clientID
			}&response_type=code`;
		}
	} else if (LMS === 'canvas') {
		return `${
			getInstitutionData(institutionCode).domain
		}/login/oauth2/auth?client_id=${
			getInstitutionData(institutionCode).clientID
		}&response_type=code&redirect_uri=${
			getInstitutionData(institutionCode).redirect
		}/&scope=url:GET|/api/v1/users/:user_id/profile`;
	} else if (LMS === 'digitalocean') {
		if (institutionCode === 'MIAMI_BROWARD') {
			return `https://cloud.digitalocean.com/v1/oauth/authorize?client_id=${
				getInstitutionData(institutionCode).clientID
			}&redirect_uri=${
				getInstitutionData(institutionCode).domain
			}&response_type=code`;
		}
	} else if (LMS === 'blackboard') {
		const institution = getInstitutionData(institutionCode);
		return `${institution.domain}/learn/api/public/v1/oauth2/authorizationcode?response_type=code&client_id=${institution.clientID}&redirect_uri=${institution.redirect}`;
	} else if (LMS === 'populi') {
		return `https://olib-api.aquinasnetwork.com/saml/login?institution_code=${institutionCode}`;
	} else if (LMS === 'd2l' || LMS === 'brightspace') {
		const institution = getInstitutionData(institutionCode);
		return `https://auth.brightspace.com/oauth2/auth?response_type=code&client_id=${institution.clientID}&redirect_uri=${institution.redirect}/d2l-callback&scope=users:own_profile:read%20users:userdata:read`;
	} else if (LMS === 'google') {
		const googleCredentials = getGoogleCredentials(institutionCode);
		const clientId =
			options?.client_id || options?.clientId || googleCredentials.client_id;
		if (!clientId) return null;

		const redirectUri =
			options?.redirect_uri ||
			options?.redirectUri ||
			googleCredentials.redirect_uri;
		const responseType =
			options?.response_type || options?.responseType || 'code';
		const scope = options?.scope || googleCredentials.scope;
		const prompt = options?.prompt || 'select_account';
		const accessType = options?.access_type || options?.accessType || 'online';
		const state = options?.state || 'google';

		const params = new URLSearchParams({
			client_id: clientId,
			redirect_uri: redirectUri,
			response_type: responseType,
			scope,
			prompt,
			access_type: accessType,
			state,
		});

		return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
	}
};
